import { render, staticRenderFns } from "./kendo-pivot.vue?vue&type=template&id=49851401&scoped=true"
import script from "./kendo-pivot.vue?vue&type=script&lang=js"
export * from "./kendo-pivot.vue?vue&type=script&lang=js"
import style0 from "./kendo-pivot.vue?vue&type=style&index=0&id=49851401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49851401",
  null
  
)

export default component.exports